import React from 'react';

var ColHeader = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'top-row' }, children);
};

export { ColHeader };
